import { TrustpilotReview } from "@sitewide/api/types";
import useSWR from "swr";

import { getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/trustpilot_reviews/latest`;

const getTrustpilotLatestReviews = getJSON<{
  data: TrustpilotReview[];
  errors: string[];
}>("Failed to load Trustpilot reviews");

export const useTrustpilotLatestReviewsQuery = () => {
  const { data, error, isLoading } = useSWR(
    API_URL,
    getTrustpilotLatestReviews,
  );

  return {
    reviews: data?.data ?? [],
    reviewsError: error || !!data?.errors?.[0],
    isLoadingReviews: isLoading,
  };
};
